const Video = {
    init() {
        if (document.querySelector('.video-block')) {
            const videos = [...document.querySelectorAll('.video-block')];
            videos.forEach(video => {
                const vidBtn = video.querySelector('.video__play-btn');
                const videoTag = video.querySelector('video');
                let playing = video.classList.contains('playing');
                if (vidBtn) {
                    vidBtn.addEventListener('click', () => {
                        console.log(playing);
                        if (!playing) {
                            playing = true;
                            videoTag.play();
                            videoTag.controls = true;
                            video.classList.add('playing');
                        } else {
                            playing = false;
                            videoTag.pause();
                            video.classList.remove('playing');
                        }
                    });
                }
            });

            const videoTriggers = [...document.querySelectorAll('.video-poster-trigger')];
            videoTriggers.forEach(trigger => {
                const { videoUrl } = trigger.dataset;
                trigger.addEventListener('click', () => {
                    const iframe = trigger.nextElementSibling;
                    iframe.src = videoUrl;
                    trigger.parentNode.removeChild(trigger);
                });
            });
        }
    },
};

export default Video;
